import * as React from 'react'
import { useEffect, useState } from 'react'
import { timeout } from '../../App'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import { AddAlert } from '@material-ui/icons'
import Snackbar from '../snackbar/Snackbar'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { initialNotificationState } from '../utils/state/ApplicationState'
import MaterialTable from 'material-table'
import { createDateFromString } from '../utils/DateUtils'
import { getApiUrl } from '../../api/api'

const columns = [
  { field: 'subtenantName', title: 'Untermieter' },
  { field: 'tenantName', title: 'Hauptmieter' },
  { field: 'universityConfirmation', title: 'Bestätigung Partneruniversität', type: 'boolean' },
  { field: 'room', title: 'Zimmer' },
  { field: 'duration', title: 'Dauer' },
  {
    field: 'movedIn',
    title: 'Einzug',
    customSort: (a, b) => createDateFromString(a.movedIn) - createDateFromString(b.movedIn),
  },
  {
    field: 'movedOut',
    title: 'Auszug',
    customSort: (a, b) => createDateFromString(a.movedOut) - createDateFromString(b.movedOut),
  },
]

export default function CurrentSubtenantTable() {
  const [notification, setNotification] = useState(initialNotificationState)

  const [proceeding, setProceeding] = useState(true)

  const [subtenants, setSubtenants] = useState([])

  useEffect(() => {
    getApiUrl({ type: 'current' })
      .get(`/admin/subtenants`)
      .then(function(response) {
        setProceeding(false)
        setSubtenants(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [notification])

  const updateUniConfirmation = (subtenantId) => {
    // const options = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    // }
    setProceeding(true)
    getApiUrl()
      .patch(`/admin/subtenants/${subtenantId}/uni-confirmation`)
      .then(function() {
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Bestätigung eingereicht.',
          color: 'success',
        })
      })
      .catch(function(error) {
        setProceeding(false)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />
      <GridItem xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={subtenants}
          title=""
          actions={[
            (rowData) => {
              return rowData.universityConfirmation
                ? { hidden: true }
                : {
                  tooltip: 'Bestätigung Partneruniversität einreichen',
                  icon: 'library_add',
                  hidden: false,
                  onClick: (event, rowData) => {
                    updateUniConfirmation(rowData.subtenantId)
                    event.stopPropagation()
                  },
                }
            },
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontWeight: 600,
            },
          }}
          localization={{
            header: {
              actions: 'Aktion',
            },
            pagination: {
              labelDisplayedRows: '{from}-{to} von {count}',
              labelRowsSelect: 'Einträge',
              labelRowsPerPage: 'Zeilen pro Seite',
            },
            toolbar: {
              nRowsSelected: '{0} Zeile(n) ',
              searchPlaceholder: 'Suchen',
              searchTooltip: 'Suchen',
            },
            body: {
              emptyDataSourceMessage: 'Keine Daten vorhanden.',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
        />
      </GridItem>
    </GridContainer>
  )
}
